import { Login, Logout } from '@mui/icons-material'
import { Button, Card, CardContent, IconButton, Skeleton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import SimpleTable from 'common/components/SimpleTable'
import useCurrentMenu from 'common/hooks/useCurrentMenu'
import { getLocaleFromFullDate } from 'common/libs/fechas'
import { colorEntradaMap, tiposEntradaMap } from 'features/control_presencia/libs/tiposEntradaMap'
import { colorSalidaMap, tiposSalidaMap } from 'features/control_presencia/libs/tiposSalidaMap'
import { Icon } from 'icons/Icons'
import { useNavigate } from 'react-router-dom'

/**
 *
 * @module ControlPresencia
 *
 */

/**
 * @callback setFichajeActiveRecord
 * @param {FichajesDTO} item
 */

/**
 *
 * Listado de ultimos fichajes
 *
 * @param {object} props
 * @param {Array<FichajesDTO>} props.response - Listado de fichajes
 */
const LastFichajesTable = ({ response, sx, loading, onClick = () => {} }) => {
  const menu = useCurrentMenu()
  const navigate = useNavigate()

  const handleReport = () => {
    navigate(`/informes/`, { state: { report: menu?.actualMatch?.parametros?.INF_HISTORICO } })
  }

  return (
    <Box
      sx={{
        borderRadius: '5px',
        width: '100%',
        ...sx,
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ my: 2 }} textAlign="left">
          Últimos Fichajes
        </Typography>
        {menu?.actualMatch?.parametros?.INF_HISTORICO ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon icon="TimePast" />}
            onClick={handleReport}
            sx={{ mb: 2 }}
          >
            Histórico de Fichajes
          </Button>
        ) : (
          <></>
        )}
      </Box>
      {loading ? (
        <Card>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Skeleton variant="rounded" height={60} sx={{ width: '100%', borderRadius: 2 }} />
            <Skeleton variant="rounded" height={60} sx={{ width: '100%', borderRadius: 2 }} />
            <Skeleton variant="rounded" height={60} sx={{ width: '100%', borderRadius: 2 }} />
          </CardContent>
        </Card>
      ) : (
        <SimpleTable
          loading={loading}
          header_cell_style={{ padding: '5px' }}
          table_style={{ width: '100%', borderCollapse: 'collapse', display: 'table' }}
          generic_cell_style={{
            textAlign: 'left',
            padding: '15px 10px',
            fontWeight: '300',
            fontSize: '0.9rem',
          }}
          hideHeader={true}
          dataSource={response}
          onRowClick={onClick}
          fields={[
            {
              field: 'entrada_salida',
              title: 'Acción',
              customGetter: (
                /** @type {FichajesDTO} */
                item,
              ) => {
                if (item.entrada_salida !== 'S') {
                  const Icon = tiposEntradaMap[item?.tipo_salida ?? 'DEFAULT'] ?? Login
                  const color = colorEntradaMap[item?.tipo_salida ?? 'DEFAULT'] ?? 'success'
                  return <Icon color={color} style={{ color: color, fontSize: '2rem' }} />
                } else {
                  const Icon = tiposSalidaMap[item?.tipo_salida ?? 'DEFAULT'] ?? Logout
                  const color = colorSalidaMap[item?.tipo_salida ?? 'DEFAULT'] ?? 'error'
                  return <Icon color={color} style={{ color: color, fontSize: '2rem' }} />
                }
              },
            },
            {
              field: 'fecha_terminal',
              title: 'Momento',
              customGetter: (
                /**@type {FichajesDTO}*/
                item,
              ) => {
                return (
                  <Box
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography variant="body1">{item.d_tipo_salida ?? 'ENTRADA'}</Typography>
                      <Typography variant="subtitle2">
                        {getLocaleFromFullDate(item.fecha_terminal, true)}
                      </Typography>
                    </Box>
                    {item.can_delete ? (
                      <IconButton>
                        <Icon data-fichaje={item.id} icon="fi-rr-trash-xmark" color="error.main" />
                      </IconButton>
                    ) : (
                      <></>
                    )}
                  </Box>
                )
              },
            },
          ]}
        />
      )}
    </Box>
  )
}

export default LastFichajesTable
